module.exports = __webpack_public_path__ + "img/source04_06.2f39ed6a.png";